import { VscChromeClose } from "react-icons/vsc";

type Props = {
    show: boolean,
    onClick: any,
    children: any
}

export default function ModalFull({ show, onClick, children }: Props) {
    return !show
        ? (
            <>
            </>
        )
        : (
            <>
                <div className="h-screen w-full flex justify-center items-center" style={{ zIndex: 99999999, position: "fixed", top: 0, left: 0, backgroundColor: "#0009" }}>
                    <div className="absolute w-8 right-16 top-10 text-white">
                        <VscChromeClose size="md" onClick={onClick} className="cursor-pointer text-orange-300 md:text-white"/>
                    </div>
                    {children}
                </div>
            </>
        )

}